import type { QueryClient } from '@tanstack/react-query';
import { BinderStage } from '@ata-digital/client-tax-system-api-client';
import { taxBinderQueryOptions } from '@/lib/query/options';

/**
 * Determines where to navigate after a client is selected.
 *
 * Fetches the client's binders and returns:
 * - Single active binder → `/tax-binders/$binderId`
 * - No active binders but completed ones → `/tax-binders`
 * - Multiple active binders or no binders at all → `/`
 */
export async function resolveClientDestination(
  queryClient: QueryClient,
  token: string,
  clientId: string
): Promise<{ to: string; params?: Record<string, string> }> {
  const bindersResponse = await queryClient.ensureQueryData(taxBinderQueryOptions.list({}, token, clientId));

  const allBinders = bindersResponse?.data?.items || [];
  const activeBinders = allBinders.filter((binder) => binder.stage !== BinderStage.Complete);

  if (activeBinders.length === 1 && activeBinders[0].id) {
    return { to: '/tax-binders/$binderId', params: { binderId: activeBinders[0].id } };
  }

  if (activeBinders.length === 0 && allBinders.length > 0) {
    return { to: '/tax-binders' };
  }

  return { to: '/' };
}
